<template>
  <div :class="$style.base">
    <div :class="$style.header">
      <BaseHeading center>
        {{ $t('register.salonized_pay.landing.pricing_section.heading') }}
      </BaseHeading>
      <BaseSwitch
        v-model="activeTab"
        :options="tabOptions"
        :class="$style.switch"
      />
    </div>
    <div :class="$style.pricing">
      <div v-if="activeTab === 'in-store'">
        <div :class="$style.line">
          <BaseText color="inverted">
            {{ $t('register.salonized_pay.landing.pricing_section.title_1') }}
          </BaseText>
          <BaseText color="inverted" bold>
            {{ $t('register.salonized_pay.landing.pricing_section.description_1') }}
          </BaseText>
        </div>
        <div :class="$style.line">
          <BaseText color="inverted">
            {{ $t('register.salonized_pay.landing.pricing_section.title_2') }}
          </BaseText>
          <BaseText color="inverted" bold>
            {{ $t('register.salonized_pay.landing.pricing_section.description_2') }}
          </BaseText>
        </div>
        <div :class="$style.line">
          <BaseText color="inverted">
            {{ $t('register.salonized_pay.landing.pricing_section.title_3') }}
          </BaseText>
          <BaseText color="inverted" bold>
            {{ $t('register.salonized_pay.landing.pricing_section.description_3') }}
          </BaseText>
        </div>
      </div>
      <div v-if="activeTab === 'online'">
        <!-- Placeholder for Online Payments -->
        <div v-for="option in onlinePaymentOptions" :key="option.title" :class="$style.line">
          <BaseText color="inverted">
            {{ option.title }}
          </BaseText>
          <BaseText color="inverted" bold>
            {{ option.description }}
          </BaseText>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const activeTab = ref('in-store');

const tabOptions = ref([
  {
    label: t(
      'register.salonized_pay.landing.pricing_section.tab_instore_label',
    ),
    value: 'in-store',
  },
  {
    label: t('register.salonized_pay.landing.pricing_section.tab_online_label'),
    value: 'online',
  },
]);
const onlinePaymentOptions = [
  {
    title: t(
      'register.salonized_pay.landing.pricing_section.online_payments.title_1',
    ),
    description: t(
      'register.salonized_pay.landing.pricing_section.online_payments.description_1',
    ),
  },
  {
    title: t(
      'register.salonized_pay.landing.pricing_section.online_payments.title_2',
    ),
    description: t(
      'register.salonized_pay.landing.pricing_section.online_payments.description_2',
    ),
  },
  {
    title: t(
      'register.salonized_pay.landing.pricing_section.online_payments.title_3',
    ),
    description: t(
      'register.salonized_pay.landing.pricing_section.online_payments.description_3',
    ),
  },
  {
    title: t(
      'register.salonized_pay.landing.pricing_section.online_payments.title_4',
    ),
    description: t(
      'register.salonized_pay.landing.pricing_section.online_payments.description_4',
    ),
  },
  {
    title: t(
      'register.salonized_pay.landing.pricing_section.online_payments.title_5',
    ),
    description: t(
      'register.salonized_pay.landing.pricing_section.online_payments.description_5',
    ),
  },
  {
    title: t(
      'register.salonized_pay.landing.pricing_section.online_payments.title_6',
    ),
    description: t(
      'register.salonized_pay.landing.pricing_section.online_payments.description_6',
    ),
  },
];
</script>

<style lang="scss" module>
.base {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  width: 950px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: $spacing;
}

.pricing {
  background-size: 100% 100%;
  background-position:
    0px 0px,
    0px 0px,
    0px 0px,
    0px 0px;
  background-image: radial-gradient(
      70% 300% at 5% 104%,
      #c9c8ee5a 1%,
      #073aff00 30%
    ),
    radial-gradient(30% 180% at 35% 12%, #03cfa644 0.1%, #073aff00 30%),
    radial-gradient(20% 100% at 105% 51%, #c9c8ee70 1%, #073aff00 30%),
    linear-gradient(136deg, #262563 24.66%, #6d73db 98.66%);
  border-radius: $radius;
  padding: $spacing;
  width: 100%;
}

.switchContainer {
  width: 100%;
  margin-bottom: $spacing * 2;
}

.switch {
  // Specific styles for BaseSwitch if needed, beyond what BaseFlex provides.
  // For example, if BaseSwitch itself needs width adjustments or similar.
}

.line {
  display: flex;
  justify-content: space-between;
  border: none;
  padding: $spacing 0px $spacing 0px;
  &:not(:last-of-type) {
    border-bottom: 1px solid $color-primary-light;
  }
}
</style>
